/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$promo-flag-border-radius: 0 !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: flex;
}

.#{$prefix}promo-flag {
  background: v(backgroundColor);
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;
  justify-content: center;
  height: 52px;
  max-width: 100%;
  border-top-left-radius: $promo-flag-border-radius;
  border-top-right-radius: $promo-flag-border-radius;

  &-multiline {
    .#{$prefix}promo-flag-text {
      font-size: 20px;
      line-height: 23px;
      font-weight: bold;
      overflow: hidden;
    }

    &.#{$prefix}alignment-center {
      .#{$prefix}promo-flag-text {
        flex: 1;
      }
    }
  }

  &-small {
    padding: 0 16px;
    height: 36px;

    .#{$prefix}promo-flag-text {
      font-size: 18px;
      line-height: 22px;
    }

    .#{$prefix}promo-flag-icon {
      margin-left: 8px;
    }

    &.#{$prefix}promo-flag-multiline {
      .#{$prefix}promo-flag-text {
        font-size: 14px;
        line-height: 16px;
      }
    }
  }

  &.#{$prefix}has-icon {
    .#{$prefix}promo-flag-text {
      width: calc(100% - 36px);
    }

    &.#{$prefix}promo-flag-small {
      .#{$prefix}promo-flag-text {
        width: calc(100% - 26px);
      }
    }
  }

  &-text {
    font-family: $heading-h5-font-family;
    font-weight: 700;
    color: v(textColor);
    font-size: 26px;
    line-height: 30px;
    width: 100%;

    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      width: 100%;
    }
  }

  &-icon {
    margin-left: 16px;
  }

  &.#{$prefix}alignment-left {
    border-bottom-right-radius: $promo-flag-border-radius;
  }

  &.#{$prefix}alignment-right {
    border-bottom-left-radius: $promo-flag-border-radius;

    span {
      text-align: right;
    }
  }

  &.#{$prefix}alignment-center {
    width: 100%;
  }
}
